module.exports = __webpack_public_path__ + "img/232-88f3f5.png";